module.exports = __webpack_public_path__ + "img/icon_road2.07a0586b.png";